import BarekamButton, { HeaderButtons } from '../../../components/button';
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import BarekamText from "../../../components/text";
import { getCurrentBalance } from "../../../../redux/slices/balance-slice";
import { useNavigate } from "react-router-dom";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { BarekamIcon, IconVariants } from "../../../components/icon/barekam-icon";

const WalletButton = ({ isDesktop, isTablet, hasValidatedRecipient }: WalletButtonProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { balance } = useAppSelector(state => state.balanceReducer);

    const amdBalanceModel = balance.find(balanceModel => balanceModel.currency.currencyId === 2);
    const amdAmount = amdBalanceModel ? amdBalanceModel.amount : 0;

    useEffect(() => {
        dispatch(getCurrentBalance());
    }, []);


    const handleButtonClick = () => {
        navigate('user/balance');
    }

    const ButtonContent = () => <>
        <BarekamIcon variant={IconVariants.creditCard} />
        <BarekamText variant={"header"} bold>
            {amdAmount} <Message messageKey={'amd'}
                sectionId={MessageSections.MAIN} />
        </BarekamText>
    </>

    if (!hasValidatedRecipient) return null;

    if (isDesktop || isTablet) {
        return (
            <BarekamButton type={HeaderButtons.SIMPLE} onClick={() => handleButtonClick()}>
                <ButtonContent />
            </BarekamButton>
        );
    } else {
        return <ButtonContent />;
    }
};

interface WalletButtonProps {
    isDesktop: boolean,
    isTablet: boolean,
    hasValidatedRecipient: boolean
}

export default WalletButton;
